<template lang="html">
  <div class="selection__container">
    <div class="header__container">
      <div class="selection__header">
        <input v-model="searchKey" placeholder="Search" data-cy="inputSearchFlag" />
      </div>
      <div class="selection__title">{{ $t('country_select_label') }}</div>
    </div>
    <div class="selection__content">
      <b-list-group v-if="countries.length > 0" class="list" data-cy="viewListFlag">
        <b-list-group-item
          v-for="(country, index) in countries"
          :key="index"
          :data-cy="'buttonFlag' + index"
          class="item"
          @click="updateCountry(country)"
        >
          <div class="countryFlag">
            <img :src="flagCountry(country.name)" :alt="country.name" />
            <span class="code">{{ country.phoneCode }}</span>
          </div>
          <span class="name">{{ country.name }}</span>
        </b-list-group-item>
      </b-list-group>
      <div v-else class="empty-list">{{ $t('country_notfound') }}</div>
    </div>
    <div :style="{ top: [top] }" class="char__group qwd">
      <div
        v-for="filterChar in listFilter"
        :key="filterChar"
        :class="{ active: filterKey === filterChar }"
        class="char"
        @click="filterKey = filterChar"
      >
        {{ filterChar }}
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/static/data/countryList.json';

export default {
  props: {
    top: {
      type: String,
      default: '120px'
    }
  },
  data() {
    return {
      show: true,
      searchKey: '',
      filterKey: '#',
      listFilter: '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    };
  },
  computed: {
    countries() {
      const filteredCountries = list.filter(country => {
        const key = this.searchKey.toLowerCase();
        const filterKey = this.filterKey.toLowerCase();
        const name = country.name.toLowerCase();
        if (filterKey !== '#') {
          return name[0] === filterKey && name.indexOf(key) >= 0;
        }
        return name.indexOf(key) >= 0;
      });
      return filteredCountries;
    }
  },
  methods: {
    updateCountry(data) {
      this.$emit('update-country', data);
    },
    flagCountry(data) {
      if (data.length > 0) {
        return `/images/icons/flags/${data.replace(/ /g, '_')}.png`;
      }
      return this.computedCountry.name;
    },
    checkCara(cara, index) {
      if (index === 0) return cara;
      if (cara === this.countries[index - 1].name[0]) return '';
      return cara;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~/assets/css/var.scss';

.selection__container {
  position: relative;
  .selection__header {
    background-color: #f6f9ff;
    padding: 25px 20px;
    position: relative;
    z-index: 10;
    input {
      width: 100%;
      text-align: center;
      border-radius: 999px;
      border: 0;
      padding: 5px 0;
    }
  }
  .selection__title {
    text-align: left;
    background-color: #ffffff;
    color: #4a494a;
    font-size: 12px;
    .item:hover {
      background-color: blue;
      color: white;
    }
    padding: 10px 20px;
    position: relative;
    z-index: 10;
  }

  .header__container {
    position: fixed;
    z-index: 1;
    width: 100%;
    max-width: 480px;
  }
  .empty-list {
    padding-top: 50%;
    text-align: center;
    font-size: 12px;
  }
  .selection__content {
    padding-top: 30%;
    @media screen and (max-width: 320px) {
      padding-top: 35%;
    }
    @media screen and (max-width: 360px) {
      padding-top: 32%;
    }
    position: relative;
    text-align: left;
    .list {
      // padding-bottom: 200px;
      overflow-y: scroll; /* has to be scroll, not auto */
      -webkit-overflow-scrolling: touch;
      .item {
        padding: 10px 20px;
        border-radius: 0;
        border: 0;
        cursor: pointer;
        .item:hover {
          background-color: blue;
          color: white;
        }
        .countryFlag {
          width: 80px;
          display: inline-block;
          img {
            width: 30px;
            vertical-align: middle;
            border: 1px solid #a2aac3;
          }
          .code {
            margin-left: 10px;
            vertical-align: middle;
          }
        }
        .name {
          margin-left: 30px;
          vertical-align: middle;
        }
      }
      .item:nth-child(even) {
        background-color: #f9fafc;
      }
      .item:nth-child(odd) {
        background-color: #ffffff;
      }
      /* .item:hover {
                background-color: blue;
                color: white;
            } */
    }
  }
  .char__group {
    position: fixed;
    text-align: center;
    width: 30px;
    right: 0px;
    padding-top: 15%;
    height: 100%;
    // overflow-y: auto;
    // padding-bottom: 200px;
    z-index: 10;
    .char {
      // margin-bottom: 10px;
      font-size: 11px;
      color: #d5d5d5;
    }
    .char.active {
      color: $primary-color;
    }
  }
}
@media screen and (min-width: $break-desktop) {
  .char {
    font-size: 12px !important;
  }
}
</style>
